import * as React from 'react';
import {TextArea} from "semantic-ui-react";
import {Column, isNavigationKey} from '../components/BasicDataGrid';
import ABaseColumn, {IBaseColumnProps, IBaseColumnState, IColumnDefinition} from './BaseColumn';
import ReactDOM from 'react-dom';
import * as _ from 'lodash';

interface ITextFieldColumn {
    // disable some properties
    errorText?: string;
    disabled?: boolean;
    readonly?: boolean;
    underlineShow?: boolean;
    onFocus?(event: React.FocusEvent<{}>, newValue: string): void;
    onBlur?(event: React.FocusEvent<{}>, newValue: string): void;
    onChange?(event: React.FormEvent<{}>, newValue: string): void;
    onKeyDown?(event: React.KeyboardEvent<{}>): any;
    onKeyPress?(event: React.KeyboardEvent<{}>): any;
    onKeyUp?(event: React.KeyboardEvent<{}>): any;
    id?: undefined;
    value?: string;
}

export interface TextFieldColumnPropsDefinition extends Column, ITextFieldColumn {
}

interface ITextFieldColumnPropsDefinition extends IColumnDefinition, ITextFieldColumn {
}

interface ITextFieldColumnProps extends IBaseColumnProps {
    /** information about the column, filled only in edit mode */
    column?: ITextFieldColumnPropsDefinition;
}

// TODO XSVX001-200 This component is no longer used
// except in ColumnFactory, which should also be refactored
/**
 * TextFieldColumn.
 * @author akirillov
 */
export default class TextFieldColumn<P extends ITextFieldColumnProps = ITextFieldColumnProps, S extends IBaseColumnState = IBaseColumnState> extends ABaseColumn<P, S>
{
    protected renderTextField = (props: ITextFieldColumn) => {
        const validTextAreaProps = _.omit(props, [
            "formatter",
            "editor",
            "editable",
            "headerRenderer",
            "sortable",
            "filterable",
            "exactFiltering",
            "resizable",
            "minRowHeight",
            "keyEditable",
            "multiLine",
            "cellRenderer",
            "visible",
            "originIndex",
            "rowKey",
            "valueStateHeight",
            "getGrid",
            "getRowMetaData",
            "filterRenderer",
            "filterValid",
            "readonly",
            "underlineShow"
        ]);

        return (
            <>
                <TextArea
                    id={this.getId()}
                    {...validTextAreaProps}
                    className={"textFieldColumn_TextArea"}
                    disabled={props.disabled}
                    onBlur={props.onBlur}
                    key={props.id}
                    value={props.value}
                    ref={(ref: any) => this.setInputNode(ref ? ref : ReactDOM.findDOMNode(this))}
                    onChange={(e: React.FormEvent<{}>, v: {value: string}) => {
                        if (!props.readonly && props.onChange) {
                            props.onChange(e, v.value.toString());
                        }
                    }}
                    onFocus={props.onFocus}
                    onKeyDown={(event: React.KeyboardEvent<{}>) => {
                        if (isNavigationKey(event.key)) {
                            event.stopPropagation();
                        }
                    }}
                    onKeyUp={(event: React.KeyboardEvent<{}>) => {
                        if (isNavigationKey(event.key)) {
                            event.stopPropagation();
                        }
                    }}
                    onKeyPress={(event: React.KeyboardEvent<{}>) => {
                        if (isNavigationKey(event.key)) {
                            event.stopPropagation();
                        }
                    }}
                />
            </>
        );
    }
    /**
     * custom rendering of value part
     * @param editMode rendering in edit mode or not
     */
    renderCustom(editMode: boolean) {
        const props: ITextFieldColumn = Object.assign(
            {},
            this.state.column,
            {
                readonly: !editMode,
                underlineShow: editMode,
                value: (this.state.value !== undefined && this.state.value !== null) ? this.state.value.toString() : '',
                onChange: (event: React.FormEvent<{}>, newValue: string) => this.onChange(newValue)
            }
        );
        return this.renderTextField(props);
    }
}



// WEBPACK FOOTER //
// ./src/components/TextFieldColumn.tsx